function Loading() {
    return (
      <>
        <div id="loadingc" align="center"><img src="/img/200.gif" alt="Loading" /></div>
      </>
    );
}
  
export default Loading;